import React from "react";

import MadFormScreen from "./MadFormScreen";

const NewMadScreen = () => {
  return <MadFormScreen mad={null} madLoading={false} />;
};

export default NewMadScreen;
